import { create } from "zustand";
import { Profile } from "../models/Profile";
import { Quote } from "../models/Quote";
import {
  AddQuoteItemDto,
  CreateQuoteDto,
  UpdateQuoteDto,
} from "../models/dto/QuoteDTO";
import {
  addQuoteItem,
  createQuote,
  deleteQuote,
  deleteQuoteItem,
  editQuoteItem,
  getAllQuotes,
  getQuote,
  updateQuote,
} from "../repositories/QuotesRepository";
import { HTTPResponse } from "../models/global/HTTPResponse";

export interface QuoteStore {
  quotes?: Quote[];
  fetchQuotes: (user: Profile) => Promise<Quote[] | undefined>;
  fetchQuote: (
    user: Profile,
    quoteId: number
  ) => Promise<HTTPResponse<Quote> | undefined>;
  addQuote: (
    user: Profile,
    quoteDto: CreateQuoteDto
  ) => Promise<HTTPResponse<Quote> | undefined>;
  addQuoteItem: (
    user: Profile,
    quoteId: number,
    quoteItem: AddQuoteItemDto
  ) => Promise<number | undefined>;
  updateQuoteItem: (
    user: Profile,
    quoteId: number,
    quoteItemId: number,
    quoteItem: AddQuoteItemDto
  ) => Promise<number | undefined>;
  removeQuoteItem: (
    user: Profile,
    quoteId: number,
    quoteItemId: number,
  ) => Promise<number | undefined>;
  editQuote: (
    user: Profile,
    quote: UpdateQuoteDto,
    quoteItemId: number,
    quoteId: number
  ) => Promise<number | undefined>;
  removeQuote: (user: Profile, quoteId: number) => Promise<number | undefined>;
}

export const useQuote = create<QuoteStore>((set) => ({
  fetchQuotes: (user) => {
    return getAllQuotes(set, user);
  },
  fetchQuote: (user, id) => {
    return getQuote(user, id);
  },
  addQuote: (user, quote) => {
    return createQuote(user, quote);
  },
  addQuoteItem: (user, quoteId, quoteItem) => {
    return addQuoteItem(user, quoteId, quoteItem);
  },
  updateQuoteItem: (user, quoteId, quoteItemId, quoteItem) => {
    return editQuoteItem(user, quoteId, quoteItemId, quoteItem);
  },
  removeQuoteItem: (user, quoteId, quoteItemId) => {
    return deleteQuoteItem(user, quoteId, quoteItemId);
  },
  editQuote: (user, quote, quoteId) => {
    return updateQuote(user, quote, quoteId);
  },

  removeQuote: (user, quoteId) => {
    return deleteQuote(user, quoteId);
  },
}));
